module.exports = __webpack_public_path__ + "img/mobile/Background/landscape_paytable_background@1.5x.jpg?1.1.2";